import { render, staticRenderFns } from "./BranchInformation.vue?vue&type=template&id=5bacd83c&scoped=true"
import script from "./BranchInformation.vue?vue&type=script&lang=js"
export * from "./BranchInformation.vue?vue&type=script&lang=js"
import style0 from "./BranchInformation.vue?vue&type=style&index=0&id=5bacd83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bacd83c",
  null
  
)

export default component.exports